<template>
  <ClientOnly>
    <Suspense>
      <template #default>
        <AgeConfirmationPopup v-if="!userStore.ageConfirmed" />
        <div v-else>
          <TourClassicNavigation />
          <div class="w-full flex flex-col items-center">
            <slot />
          </div>
          <Footer />
        </div>
      </template>

      <template #fallback>
        <FullScreenLoader :open="true" />
      </template>
    </Suspense>

    <BillerEpochJoinBox />
    <SaleSpecial />
  </ClientOnly>
</template>

<script setup>
  const userStore = useUserStore()

  useHead({
    bodyAttrs: {
      class: "tour-classic",
    },
  })
</script>
